<!--公告及新闻稿-->
<template>
  <div>
    <transition name="moveing">
      <navgate-other ref="topTitle" v-show="isShowTopTitle" @lang-change="onLangChange"></navgate-other>
    </transition>
    
    <main class="index_main_content">
      <div class="index_main_body other" ref="topDiv">
        <div class="zcgy_img"><img src="../../../assets/img/investor/touzizhe-banner.jpg"><div class="mask_bg"></div></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">{{ $t('investor.banner.ch') }}</div>
          <div class="zcgy_en">{{ $t('investor.banner.en') }}</div>
        </div>
      </div>
      <!--二级导航定格-->
      <div class="second_nav_top" v-show="lockSecondTop" >
        <div class="second_nav_list">
          <div :class="{active_d:(selectedSecond == '公告及新闻稿')}" @click="clickSecondHandler('公告及新闻稿')">{{ $t('investor.tabs.report') }}</div>
          <div :class="{active_d:(selectedSecond == '财务报告')}" @click="clickSecondHandler('财务报告')">{{ $t('investor.tabs.finReport') }}</div>
          <div :class="{active_d:(selectedSecond == '董事会')}" @click="clickSecondHandler('董事会')">{{ $t('investor.tabs.court') }}</div>
          <div :class="{active_d:(selectedSecond == '公司信息')}" @click="clickSecondHandler('公司信息')">{{ $t('investor.tabs.company') }}</div>
          <div :class="{active_d:(selectedSecond == '电话会议')}" @click="clickSecondHandler('电话会议')">{{ $t('investor.tabs.telMeeting') }}</div>
          <div :class="{active_d:(selectedSecond == '分析师')}" @click="clickSecondHandler('分析师')">{{ $t('investor.tabs.analyst') }}</div>
          <div :class="{active_d:(selectedSecond == '企业管治文件')}" @click="clickSecondHandler('企业管治文件')">{{ $t('investor.tabs.businessFile') }}</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="clickSecondHandler('联系我们')">{{ $t('investor.tabs.contactUs') }}</div>
          <div :class="{active_d:(selectedSecond == '常见问题')}" @click="clickSecondHandler('常见问题')">{{ $t('investor.tabs.faq') }}</div>
          <!--<div :class="{active_d:(selectedSecond == 'Investor Relations')}" @click="clickSecondHandler('Investor Relations')">{{ $t('investor.tabs.investorEn') }}</div>
          -->
        </div>
      </div>
      <!--二级导航-->
      <div class="second_nav" ref="secondNav">
        <div class="second_nav_list">
          <div :class="{active_d:(selectedSecond == '公告及新闻稿')}" @click="clickSecondHandler('公告及新闻稿')">{{ $t('investor.tabs.report') }}</div>
          <div :class="{active_d:(selectedSecond == '财务报告')}" @click="clickSecondHandler('财务报告')">{{ $t('investor.tabs.finReport') }}</div>
          <div :class="{active_d:(selectedSecond == '董事会')}" @click="clickSecondHandler('董事会')">{{ $t('investor.tabs.court') }}</div>
          <div :class="{active_d:(selectedSecond == '公司信息')}" @click="clickSecondHandler('公司信息')">{{ $t('investor.tabs.company') }}</div>
          <div :class="{active_d:(selectedSecond == '电话会议')}" @click="clickSecondHandler('电话会议')">{{ $t('investor.tabs.telMeeting') }}</div>
          <div :class="{active_d:(selectedSecond == '分析师')}" @click="clickSecondHandler('分析师')">{{ $t('investor.tabs.analyst') }}</div>
          <div :class="{active_d:(selectedSecond == '企业管治文件')}" @click="clickSecondHandler('企业管治文件')">{{ $t('investor.tabs.businessFile') }}</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="clickSecondHandler('联系我们')">{{ $t('investor.tabs.contactUs') }}</div>
          <div :class="{active_d:(selectedSecond == '常见问题')}" @click="clickSecondHandler('常见问题')">{{ $t('investor.tabs.faq') }}</div>
          <!--
          <div :class="{active_d:(selectedSecond == 'Investor Relations')}" @click="clickSecondHandler('Investor Relations')">{{ $t('investor.tabs.investorEn') }}</div>
          -->
        </div>
      </div>
      <!--内容-->
      <investorReport ref="investorReport" v-show="selectedSecond == '公告及新闻稿'" :conditionNewsList="conditionNewsList"></investorReport>
      <investorCourt v-show="selectedSecond == '董事会'" ></investorCourt>
      <investorCompany v-show="selectedSecond == '公司信息'" ></investorCompany>
      <investorTelMeeting ref="investorTelMeeting" v-show="selectedSecond == '电话会议'" :telMeetingList="telMeetingList"></investorTelMeeting>
      <investorFinReport ref="investorFinReport" v-show="selectedSecond == '财务报告'" :finYearsReportList="finYearsReportList"></investorFinReport>
      <investorAnalyst v-show="selectedSecond == '分析师'"></investorAnalyst>
      <investorBusinessFile v-show="selectedSecond == '企业管治文件'" :businessFileList="businessFileList"></investorBusinessFile>
      <investorContactUs v-show="selectedSecond == '联系我们'"></investorContactUs>
      <investorQuestions v-show="selectedSecond == '常见问题'"></investorQuestions>

    </main>
    <footer-build @gotoBody="gotoBody"></footer-build>
  </div>
</template>

<script>
import YearsTitleListView from '../titleNews/YearsTitleListView'
import investorReport from './investorBox/investorReport'
import UtilEvent from '../utils/UtilEvent.js'
import investorCourt from './investorBox/investorCourt'
import investorCompany from './investorBox/investorCompany'
import investorTelMeeting from './investorBox/investorTelMeeting'
import investorFinReport from './investorBox/investorFinReport'
import investorAnalyst from './investorBox/investorAnalyst'
import investorBusinessFile from './investorBox/investorBusinessFile'
import investorContactUs from './investorBox/investorContactUs'
import investorQuestions from './investorBox/investorQuestions'

export default {
  name: 'newsList',
  components: {
    UtilEvent,
    YearsTitleListView,
    investorReport,
    investorQuestions,
    investorCourt,
    investorTelMeeting,
    investorContactUs,
    investorFinReport,
    investorAnalyst,
    investorBusinessFile,
    investorCompany
  },
  props: {},
  created() {
  },
  data () {
    return {
      conditionNewsList: {total: 0, perPage: 1, yearList: [], list: []},
      telMeetingList: {total: 0, perPage: 1, yearList: [], list: []},
      finYearsReportList: {total: 0, perPage: 1, yearList: [], list: []},
      businessFileList: {total: 0, perPage: 1, yearList: [], list: []},
      oldScrollTop: 0,
      isShowTopTitle: true,
      showSecondTitle: false,
      lockSecondTop: false,
      topDivHeight: 0,
      selectedSecond: '公告及新闻稿'
    }
  },
  computed: {
  },
  methods: {
    onLangChange(lang) {
      // 语言切换时重新加载所有数据
      new UtilEvent().getAnnoListData(this)
      new UtilEvent().getTelMeetingListData(this)
      new UtilEvent().getFinYearsReportListData(this)
      new UtilEvent().getBusinessFileListData(this)
      // 刷新新闻稿数据
      if (this.$refs.investorReport) {
        this.$refs.investorReport.reloadNoticeData()
      }
      // 刷新季度报告数据
      if (this.$refs.investorFinReport) {
        this.$refs.investorFinReport.reloadData()
      }
      // 刷新投资者活动数据
      if (this.$refs.investorTelMeeting) {
        this.$refs.investorTelMeeting.reloadData()
      }
    },
    scrolling() {
      // 获取dom滚动距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= this.topDivHeight) {
        this.lockSecondTop = true
      } else {
        this.lockSecondTop = false
      }
      let scrollStep = scrollTop - this.oldScrollTop
      this.oldScrollTop = scrollTop
      if (!this.lockSecondTop) {
        // scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
        if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
          this.isShowTopTitle = true
        } else {
          this.isShowTopTitle = false
        }
      } else {
        this.isShowTopTitle = false
      }
    },
    clickSecondHandler(name) {
      this.selectedSecond = name
      if (name == 'Investor Relations') {
        window.open('https://ir.kingsoft.com/', '_blank')
      }
      this.$refs.secondNav.scrollIntoView({
        behavior: 'smooth'
      })
    },
    gotoBody() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  watch: {
  },
  mounted() {
    // 获得头部div高度
    this.topDivHeight = this.$refs.topDiv.offsetHeight
    // 刚加载页面后会有偏移量，偏移后再去监听
    setTimeout(() => {
      window.addEventListener('scroll', this.scrolling)
    }, 300)

    // 获取新闻及公告
    new UtilEvent().getAnnoListData(this)
    // new UtilEvent().getNoticeListData(this)

    // 获得电话会议
    new UtilEvent().getTelMeetingListData(this)
    // 获得财务报告--年度报告
    new UtilEvent().getFinYearsReportListData(this)
    // 获得企业管理文件
    new UtilEvent().getBusinessFileListData(this)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrolling)
  }
}
</script>
